// ***************************************
// Definition of game token Slingshot
// ***************************************
import { tbContainer } from "../engine/tbContainer";
import { tbEase } from "../engine/tbEase";
import { tbGame } from "../engine/tbGame";
import { tbGraphics } from "../engine/tbGraphics";
import { tbVector } from "../engine/tbVector";
import { PhysicsSettings } from "../settings/PhysicsSettings";
import { SlingshotFakeAimSettings } from "../settings/Settings";
import { PhysicsObjectDefinition } from "../settings/blocks";
import { AIController } from "./AIController";
import { s_mighty_scope_bottom, s_mighty_scope_top, s_slingshot_rubber, s_slingshot_bascket, s_aiming_dot_mighty, s_aiming_dot } from "./AssetDefinitions/ImageDefinitions";
import { ExpManager } from "./ExpManager";
import { SceneControllerState, physics } from "./SceneController";
import { playController } from "./gameController";
// The constructor for the Slingshot game token. 
export var Slingshot = function (x, y, depth, isCurrentPlayer) {
    "use strict";
    // Properties used by the engine
    this.depth = depth;
    this.layer = 0;
    this.visible = true;
    this.active = true;
    // Your own properties
    this.x = x;
    this.y = y;
    this.callbackStartDrag = null;
    this.callbackEndDrag = null;
    this.isInputEnabled = false;
    this.globalStartDragPos = new tbVector(0, 0);
    this.fingerId = -1;
    this.isDragging = false;
    this.birdPosition = new tbVector(this.x, this.y);
    this.launchDirection = new tbVector(0, 0);
    this.launchAngle = 0;
    this.launchForce = 0;
    this.rubberSnapPointBack = new tbVector(1.75, 0);
    this.rubberSnapPointFront = new tbVector(-2, 0);
    this.cappedRatio = 0.2;
    this.startCapAngle = -Math.PI / 2 + 0.1;
    this.minCapAngle = -Math.PI / 2 + 0;
    this.maxCapAngle = -Math.PI / 2 - 0.2;
    this.endCapAngle = -Math.PI / 2 - 0.3;
    this._isFakeAiming = false;
    this._fakeAimData = {
        timer: 0,
        destPos: [],
        storedPos: [],
        currPos: { x: 0, y: 0 },
        currPosIndex: -1,
        callback: function () { }
    };
    this.trailPointsPoolSize = 80;
    this.trajectoryStep = 5;
    this.trajectoryCount = 0;
    this.trailImpact = { x: 0, y: 0 };
    this.isCurrentPlayer = isCurrentPlayer;
    // Add it to the game engine
    tbGame.addToken(this);
};
Slingshot.prototype.StartFakingAim = function (finalPos, callback) {
    this._isFakeAiming = true;
    this.isInputEnabled = false;
    this._fakeAimData["timer"] = 0;
    this._fakeAimData["currPosIndex"] = 0;
    this._fakeAimData["destPos"] = [
        { x: 0, y: 0 },
        //this._generateFakeAimPosition(false, true),
        //this._generateFakeAimPosition(false, true), 
        //this._generateFakeAimPosition(false, true), 
        finalPos ? finalPos : { x: 0, y: 0 }
    ];
    if (callback)
        this._fakeAimData["callback"] = callback;
    this._fakeAimData["storedPos"].push({ x: this.birdContainer.x, y: this.birdContainer.y });
    this._fakeAimData["currPos"] = { x: 0, y: 0 };
    this.birdContainer.setPosition(0, 0);
    this.containerBascket.setPosition(0, 0);
};
Slingshot.prototype._generateFakeAimPosition = function (doX, doY) {
    var pos = { x: 0, y: 0 };
    if (doX)
        pos.x = Math.random() * 5;
    else
        pos.x = 45;
    if (doY)
        pos.y = Math.random() * 75 - 35;
    else
        pos.y = 0;
    pos.x *= -1;
    pos.y *= -1;
    return pos;
};
// handleAdd is called when the token is (re-) added to the game. 
Slingshot.prototype.handleAdd = function () {
    "use strict";
    this.scale = 1 / PhysicsSettings.textureResolution;
    this.container = new tbContainer();
    this.container.setPosition(this.x, this.y);
    var slingshot;
    if (this.isCurrentPlayer) {
        slingshot = ExpManager.getRankAssets();
    }
    else {
        if (playController.gameType == "challenge") {
            slingshot = ExpManager.getRankAssets(ExpManager.getFriendRank(playController.getOpponentId()));
        }
        else {
            slingshot = ExpManager.getRankAssets(AIController.getDisplayRank());
        }
    }
    var spriteFront = slingshot.front.clone();
    spriteFront.setScale(this.scale, this.scale);
    var spriteBack = slingshot.back.clone();
    spriteBack.setScale(this.scale, this.scale);
    this.birdContainer = new tbContainer();
    this.trailContainer = new tbContainer();
    this.birdContainer.addChild(this.trailContainer);
    this.mightyScopeContainer = new tbContainer();
    this.mightyScopeBottom = s_mighty_scope_bottom.clone();
    this.mightyScopeBottom.setPosition(1, -1);
    this.mightyScopeBottom.setScale(this.scale, this.scale);
    this.mightyScopeTop = s_mighty_scope_top.clone();
    this.mightyScopeTop.setPosition(1, -6);
    this.mightyScopeTop.setScale(this.scale, this.scale);
    this.mightyScopeContainer.addChild(this.mightyScopeTop);
    this.mightyScopeContainer.addChild(this.mightyScopeBottom);
    this.mightyScopeContainer.setAlpha(0);
    this.createDots();
    this.containerRubberBack = s_slingshot_rubber.clone();
    this.containerRubberBack.setPosition(this.rubberSnapPointBack.x, this.rubberSnapPointBack.y);
    this.containerRubberBack.setScale(this.scale, this.scale);
    this.containerRubberFront = s_slingshot_rubber.clone();
    this.containerRubberFront.setPosition(this.rubberSnapPointFront.x, this.rubberSnapPointFront.y);
    this.containerRubberFront.setScale(this.scale, this.scale);
    this.containerBascket = new tbContainer();
    var bascketSprite = s_slingshot_bascket.clone();
    bascketSprite.setScale(this.scale, this.scale);
    this.containerBascket.addChild(bascketSprite);
    this.container.addChild(this.mightyScopeContainer);
    this.container.addChild(this.containerRubberBack);
    this.container.addChild(spriteBack);
    this.container.addChild(this.birdContainer);
    this.container.addChild(this.containerRubberFront);
    this.container.addChild(this.containerBascket);
    this.container.addChild(spriteFront);
};
Slingshot.prototype.createDots = function () {
    "use strict";
    // remove existing if there are any
    if (this.trail) {
        if (this.trail.length > 0) {
            for (var index = 0; index < this.trail.length; index++) {
                this.trailContainer.removeChild(this.trail[index].container);
            }
        }
    }
    this.trail = [];
    this._slingshotLength = playController.hasMightyScope ? PhysicsSettings.slingshotMightyScopeLength : PhysicsSettings.slingshotTrailMaxLength;
    var numberOfDots = (this._slingshotLength / PhysicsSettings.slingshotTrailDistBetween);
    for (var i = 0; i < numberOfDots; i++) {
        var sprite = playController.hasMightyScope ? s_aiming_dot_mighty.clone() : s_aiming_dot.clone();
        sprite.setScale(this.scale, this.scale);
        sprite.hide();
        this.trailContainer.addChild(sprite);
        this.trail.push({ container: sprite, distance: (i * PhysicsSettings.slingshotTrailDistBetween), index: -1 });
    }
    this.trailPoints = [];
    this.trailCachedDistances = []; // at index i it holds the trajectory length from start to point[i]
    for (var i = 0; i < this.trailPointsPoolSize; i++) {
        this.trailPoints.push(new tbVector(0, 0));
        this.trailCachedDistances.push(-1);
    }
};
// handleRemove is called when the token is removed from the game.
Slingshot.prototype.handleRemove = function () {
    "use strict";
    this.container.remove();
    this.container.free();
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
Slingshot.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
    if (this.isInputEnabled) {
        var pt = new tbVector(x, y);
        this.globalStartDragPos = tbGraphics.toGlobal(this.container, new tbVector(0, 0));
        if (pt.distance(this.globalStartDragPos) <= PhysicsSettings.slingshotDraggingRadiusUI && finger == 0) {
            this.fingerId = finger;
            this.isDragging = true;
            if (this.callbackStartDrag) {
                this.callbackStartDrag();
            }
        }
    }
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
Slingshot.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
    if (this.isInputEnabled && this.isDragging && finger === this.fingerId) {
        this.isDragging = false;
        if (this.callbackEndDrag) {
            this.callbackEndDrag(!this.isValidShot);
        }
    }
};
Slingshot.prototype.handleFakeAim = function (timePassed) {
    this._fakeAimData.timer += (timePassed * SlingshotFakeAimSettings.animSpeed) * 0.001;
    var xComplete = false;
    var yComplete = false;
    var xDist = this._fakeAimData.currPos.x - this._fakeAimData.destPos[this._fakeAimData["currPosIndex"]].x;
    var yDist = this._fakeAimData.currPos.y - this._fakeAimData.destPos[this._fakeAimData["currPosIndex"]].y;
    if (xDist > 0.5 || xDist < -0.5) {
        if (this._fakeAimData["currPosIndex"] != 0) {
            this._fakeAimData.currPos.x = tbEase.easeLinear(this._fakeAimData.timer, this._fakeAimData.destPos[this._fakeAimData["currPosIndex"] - 1].x, this._fakeAimData.destPos[this._fakeAimData["currPosIndex"]].x - this._fakeAimData.destPos[this._fakeAimData["currPosIndex"] - 1].x, 0.50 * SlingshotFakeAimSettings.animSpeed);
        }
        else {
            this._fakeAimData.currPos.x = tbEase.easeLinear(this._fakeAimData.timer, 0, this._fakeAimData.destPos[this._fakeAimData["currPosIndex"]].x, 0.35 * SlingshotFakeAimSettings.animSpeed);
        }
    }
    else {
        xComplete = true;
    }
    if (yDist > 0.5 || yDist < -0.5) {
        if (this._fakeAimData["currPosIndex"] != 0) {
            this._fakeAimData.currPos.y = tbEase.easeLinear(this._fakeAimData.timer, this._fakeAimData.destPos[this._fakeAimData["currPosIndex"] - 1].y, this._fakeAimData.destPos[this._fakeAimData["currPosIndex"]].y - this._fakeAimData.destPos[this._fakeAimData["currPosIndex"] - 1].y, 0.50 * SlingshotFakeAimSettings.animSpeed);
        }
        else {
            this._fakeAimData.currPos.y = tbEase.easeLinear(this._fakeAimData.timer, 0, this._fakeAimData.destPos[this._fakeAimData["currPosIndex"]].y, 0.35 * SlingshotFakeAimSettings.animSpeed);
        }
    }
    else {
        yComplete = true;
    }
    if (xComplete && yComplete && this._fakeAimData.timer >= 1.00) {
        if (this._fakeAimData["currPosIndex"] < this._fakeAimData["destPos"].length - 1) {
            this._fakeAimData["currPosIndex"]++;
            this._fakeAimData.timer = 0;
        }
        else {
            this._fakeAimData["callback"]();
        }
    }
};
Slingshot.prototype.finishFakeAiming = function () {
    this._isFakeAiming = false;
    this._fakeAimData.timer = 0;
    this._fakeAimData["currPosIndex"] = -1;
    this.birdContainer.setRotation(0);
    this.birdContainer.setPosition(0, 0);
    this.containerBascket.setPosition(0, 0);
    this.birdSprite.remove();
    this.birdSprite.free();
};
Slingshot.prototype.handleEndStep = function (timePassed) {
    "use strict";
    if (this._isFakeAiming == true) {
        this.handleFakeAim(timePassed);
    }
    if ((this.isInputEnabled && this.isDragging) || this._isFakeAiming == true) {
        this.globalStartDragPos = tbGraphics.toGlobal(this.container, new tbVector(0, 0));
        var currentPos;
        if (this._isFakeAiming == true) {
            currentPos = tbGraphics.toGlobal(this.container, new tbVector(this._fakeAimData.currPos.x, this._fakeAimData.currPos.y));
        }
        else {
            currentPos = new tbVector(tbGame.touchX(this.fingerId), tbGame.touchY(this.fingerId));
        }
        this.launchDirection = this.globalStartDragPos.subtract(currentPos);
        var dist = Math.min(this.launchDirection.length(), PhysicsSettings.slingshotMaxSwipeDistUI);
        this.isValidShot = dist >= PhysicsSettings.slingshotCancelRadiusUI;
        this.launchDirection.x *= playController.isInitiatingPlayer ? 1 : -1;
        // TODO: TEST IF THIS WORKS FOR PLAYEER 2 (does this need to be AFTER inverting launch direction or before?)
        if (PhysicsSettings.slingshotAllowBackwardsShot == false) {
            if (playController.isInitiatingPlayer && this.launchDirection.x < 0)
                this.isValidShot = false;
            else if (!playController.isInitiatingPlayer && this.launchDirection.x > 0)
                this.isValidShot = false;
        }
        this.launchDirection.normalizeDirect();
        this.launchAngle = Math.atan2(this.launchDirection.y, (playController.isInitiatingPlayer ? 1 : -1) * this.launchDirection.x);
        //MightyScope Angle
        var scopePosition = new tbVector(this.container.x, this.container.y);
        var impactPoint = new tbVector(this.trailImpact.x, this.trailImpact.y);
        var impactDirection = scopePosition.subtract(impactPoint);
        impactDirection.normalizeDirect();
        var impactAngle = Math.atan2(-impactDirection.y, (playController.isInitiatingPlayer && playController.sceneController.state != SceneControllerState.REPLAYING ? -1 : 1) * impactDirection.x);
        var currentAngle = this.mightyScopeTop.rotation;
        var newAngle = 0;
        if (impactPoint.y > 100 || (Math.abs(this.x) - 10) < Math.abs(impactPoint.x)) {
            newAngle = currentAngle + 0.05 * (0 - currentAngle);
        }
        else {
            newAngle = currentAngle + 0.1 * (impactAngle - currentAngle);
        }
        this.mightyScopeTop.setRotation(newAngle);
        this.ratio = dist / PhysicsSettings.slingshotMaxSwipeDistUI;
        this._capRatio();
        this.launchForce = PhysicsSettings.slingshotMaxForce * this.ratio;
        var scalar = PhysicsSettings.slingshotMaxSwipe * this.ratio;
        this.birdPosition = new tbVector(this.x - (this.launchDirection.x * scalar), this.y - (this.launchDirection.y * scalar));
        var birdX = -(this.launchDirection.x * scalar) * (playController.isInitiatingPlayer ? 1 : -1);
        var birdY = -(this.launchDirection.y * scalar);
        this.birdContainer.setPosition(birdX, birdY);
        this.birdContainer.setRotation(this.launchAngle);
        this.containerBascket.setPosition(birdX, birdY);
    }
    else {
        this.birdContainer.setRotation(0);
        var currentAngle = this.mightyScopeTop.rotation;
        var newAngle = currentAngle + 0.05 * (0 - currentAngle);
        this.mightyScopeTop.setRotation(newAngle);
    }
    this._updateTrail(timePassed);
    if (this.trajectoryCount > 0) {
        var worldPt = tbGraphics.toGlobal(this.trailContainer, new tbVector(this.trailPoints[this.trajectoryCount - 1].x, this.trailPoints[this.trajectoryCount - 1].y));
        var impactPoint = this.container.container["parent"]["toLocal"](worldPt);
        this.trailImpact.x = impactPoint.x;
        this.trailImpact.y = impactPoint.y;
    }
};
Slingshot.prototype._updateTrail = function (timePassed) {
    "use strict";
    this._getTrajectory();
    if (this.isDragging && this.isValidShot) {
        this.trailContainer.show();
        for (var i = 0; i < this.trail.length; i++) {
            var p = this.trail[i];
            if (p.distance <= this.trajectoryLength - 1) {
                //we draw this point
                p.container.show();
                if (p.index < 0 || p.index >= this.trajectoryCount || this.trailCachedDistances[p.index] > p.distance) {
                    p.index = 0;
                }
                for (var k = p.index; k < this.trajectoryCount - 1; k++) {
                    if (p.distance >= this.trailCachedDistances[k] && p.distance < this.trailCachedDistances[k + 1]) {
                        p.index = k;
                        var d = p.distance - this.trailCachedDistances[k];
                        var v = this.trailPoints[k + 1].subtract(this.trailPoints[k]);
                        v.normalizeDirect();
                        v.scaleDirect(d);
                        p.container.setPosition(this.trailPoints[k].x + v.x, this.trailPoints[k].y + v.y);
                        break;
                    }
                }
                var r = 1 - (p.distance / this._slingshotLength);
                var scale = r * (PhysicsSettings.slingshotDotMaxScale - PhysicsSettings.slingshotDotMinScale) + PhysicsSettings.slingshotDotMinScale;
                p.container.setScale(this.scale * scale, this.scale * scale);
            }
            else {
                //we don't draw this point
                p.container.hide();
            }
            p.distance += (PhysicsSettings.slingshotTrailSpeed * timePassed) / 1000;
            if (p.distance >= this._slingshotLength)
                p.distance -= this._slingshotLength;
        }
    }
    else {
        this.trailContainer.hide();
    }
};
Slingshot.prototype._getTrajectory = function () {
    //take 0,0 transform it in the physic's world space,
    //get the trajectory, then transform the points back to our local space
    var worldPt = tbGraphics.toGlobal(this.trailContainer, new tbVector(0, 0));
    var startPoint = this.container.container["parent"]["toLocal"](worldPt);
    startPoint = new tbVector(startPoint.x, startPoint.y);
    var startVelocity = this.launchDirection.scale(this.launchForce);
    var radius = PhysicsObjectDefinition[this.birdType || "RedBird"].height / 2 * PhysicsSettings.physicsScale;
    this.trajectoryCount = physics.getTrajectory(this.trailPoints, startPoint, startVelocity, this.trajectoryStep, true, radius, 3);
    this.trajectoryLength = 0;
    for (var i = 0; i < this.trajectoryCount; i++) {
        var pt = this.container.container["parent"]["toGlobal"](this.trailPoints[i]);
        this.trailPoints[i] = tbGraphics.toLocal(this.trailContainer, pt);
        if (i > 0) {
            this.trajectoryLength += this.trailPoints[i].distance(this.trailPoints[i - 1]);
            this.trailCachedDistances[i] = this.trajectoryLength;
        }
        else {
            this.trailCachedDistances[i] = 0;
        }
    }
};
Slingshot.prototype.handleDraw = function () {
    "use strict";
    this.container.setPosition(this.x, this.y);
    var p = new tbVector(this.birdContainer.x, this.birdContainer.y);
    var vBack = this.rubberSnapPointBack.subtract(p);
    var ratioBack = vBack.length() / (this.containerRubberBack.width * this.scale);
    this.containerRubberBack.setScale(this.scale * ratioBack, this.scale);
    this.containerRubberBack.setRotation(Math.atan2(vBack.y, vBack.x));
    var vFront = this.rubberSnapPointFront.subtract(p);
    var ratioFront = vFront.length() / (this.containerRubberFront.width * this.scale);
    this.containerRubberFront.setScale(this.scale * ratioFront, this.scale);
    this.containerRubberFront.setRotation(Math.atan2(vFront.y, vFront.x));
    this.containerBascket.setRotation(this.launchAngle);
};
Slingshot.prototype.setInputActive = function (isActive) {
    "use strict";
    this.isInputEnabled = isActive;
};
Slingshot.prototype.setBirdType = function (type) {
    "use strict";
    this.birdPosition = new tbVector(this.x, this.y);
    this.launchDirection = new tbVector(0, 0);
    this.launchForce = 0;
    this.birdContainer.setPosition(0, 0);
    this.containerBascket.setPosition(0, 0);
    this.launchAngle = 0;
    if (this.birdSprite) {
        this.birdSprite.remove();
        this.birdSprite.free();
    }
    if (type && PhysicsObjectDefinition[type]) {
        this.birdSprite = PhysicsObjectDefinition[type].spine.clone();
        var spineScale = PhysicsObjectDefinition[type].animation.scale;
        this.birdSprite.setAnimation(PhysicsObjectDefinition[type].animation.idle, true);
        this.birdSprite.setScale(this.scale * spineScale, this.scale * spineScale);
        this.birdContainer.addChild(this.birdSprite);
        this.birdType = type;
    }
};
Slingshot.prototype._capRatio = function () {
    "use strict";
    if (this.launchAngle <= this.startCapAngle && this.launchAngle > this.minCapAngle) {
        var r = (this.launchAngle - this.startCapAngle) / (this.minCapAngle - this.startCapAngle);
        this.ratio = (1 - r) * (1 - this.cappedRatio) + this.cappedRatio;
    }
    else if (this.launchAngle <= this.minCapAngle && this.launchAngle >= this.maxCapAngle) {
        this.ratio = this.cappedRatio;
    }
    else if (this.launchAngle < this.maxCapAngle && this.launchAngle >= this.endCapAngle) {
        var r = (this.launchAngle - this.maxCapAngle) / (this.endCapAngle - this.maxCapAngle);
        this.ratio = r * (1 - this.cappedRatio) + this.cappedRatio;
    }
};
Slingshot.prototype.toggleMightyScope = function (enable) {
    var alpha;
    if (enable) {
        alpha = 1;
    }
    else {
        alpha = 0;
    }
    this.mightyScopeContainer.setAlpha(alpha);
};
